import ClearIcon from "@mui/icons-material/Clear";
import { AnimatePresence } from "framer-motion";
import {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { useLocation } from "react-router-dom";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2";
import { TabelaVirtualizadaGenerica } from "../../../../components/TabelaVirtualizadaGenerica/TabelaVirtualizadaGenerica.tsx";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { colunasEmpresaInicial } from "../../../../contexts/ContextConstants.ts";
import FiltrosRedux from "../../../../contexts/Filtros.js";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../../contexts/RequestController";
import TabelaRedux from "../../../../contexts/Tabela";
import MotionContainer from "../../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../../core/components/Separator.tsx";
import { ElegibilidadeBrf } from "../../../../core/enums/EligibilidadeBrf.ts";
import Layout from "../../../../core/layout/Layout.tsx";
import { opcoesBrfMapper } from "../../../../core/utils/elegivelBrf.ts";
import { useRowClick } from "../../../../hooks/useRowClick.ts";
import { getVeiculoDependencias } from "../../../../services/ModuloGerenciador/Geral.ts";
import { getVeiculoSearch } from "../../../../services/ModuloGerenciador/Search";
import {
	cadastraVeiculo,
	deleteVeiculoPorId,
	editaVeiculoPorId,
	getVeiculoPorId,
} from "../../../../services/ModuloGerenciador/Veiculo";
import { VerificaExistenciaVeiculo } from "../../../../services/ModuloGerenciador/VerificaExistencia";
import "./Veiculo.css";
import ModaisVeiculos from "./components/ModaisVeiculos.tsx";
import VeiculoCadastro from "./components/VeiculoCadastro.tsx";
import {
	camposObrigatorios,
	itensFiltro,
	opcoes,
	opcoesSelect,
	opcoesVeiculo,
	validadoresIniciais,
	valoresIniciais,
} from "./components/VeiculoHelpers.tsx";

const campos = [
	"placaCavalo",
	"proprietario",
	"motorista",
	"tipoCarroceria",
	"tipoVeiculoConjuntos",
];
const campos2 = [
	"caminhaoId",
	"proprietarioId",
	"motoristaId",
	"tipoCarroceriaId",
	"tipoVeiculoId",
];

function Veiculo(props) {
	const {
		hasRegra,
		contextoEmbarque,
		profile,
		shouldSearchDependencies,
	} = useProfile();

	const hasBuscadoVeiculos = useRef(false);
	const hasBuscadoVeiculoPorId = useRef(false);

	const [valuesPesquisa, setValuesPesquisa] = useState([]);
	const [dadosTabelaCopia, setDadosTabelaCopia] = useState([]);
	const [placaValida, setPlacaValida] = useState(true);
	const [erroPlacaCavalo, setErroPlacaCavalo] = useState(false);
	const [erroProprietario, setErroProprietario] = useState(false);
	const [erroMotorista, setErroMotorista] = useState(false);
	const [erroTipoCarroceria, setErroTipoCarroceria] = useState(false);
	const [erroTipoVeiculo, setErroTipoVeiculo] = useState(false);
	const [erroTipoVeiculoApiSul, setErroTipoVeiculoApiSul] = useState(false);
	const [erroElegivelBrf, setErroElegivelBrf] = useState(false);
	const [dadosTabela, setDadosTabela] = useState([]);
	const [telaCadastro, setTelaCadastro] = useState(false);
	const [editando, setEditando] = useState(false);
	const [loading, setLoading] = useState(true);
	const [loadingSelectProprietario, setLoadingSelectProprietario] =
		useState(false);
	const [loadingSelectMotorista, setLoadingSelectMotorista] = useState(false);
	const [loadingSelectCaminhao, setLoadingSelectCaminhao] = useState(false);
	const [loadingSelectCarreta, setLoadingSelectCarreta] = useState(false);
	const [loadingSelectCarroceria, setLoadingSelectCarroceria] = useState(false);
	const [loadingSelectTipoVeiculo, setLoadingSelectTipoVeiculo] =
		useState(false);
	const [values, setValues] = useState({
		agregado: false,
		telemetria: false,
		placaCavalo: "",
		placaCarreta: "",
		placaCarreta2: "",
		proprietario: "",
		motorista: "",
		motorista2: "",
		tipoCarroceria: "",
		tipoVeiculo: "",
		tipoVeiculoConjuntos: "",
		ativoDiaria: "",
		elegivelBrf: "",
	});
	const [valuesSelect, setValuesSelect] = useState([]);
	const [validator, setValidator] = useState([]);
	const [open, setOpen] = useState(false);
	const [textoSucesso, setTextoSucesso] = useState("");
	const [textoErro, setTextoErro] = useState("");
	const [listaProprietario, setListaProprietarios] = useState([]);
	const [listaMotoristas, setListaMotoristas] = useState([]);
	const [listaCaminhoes, setListaCaminhoes] = useState([]);
	const [listaCarretas, setListaCarretas] = useState([]);
	const [listaCarrocerias, setListaCarrocerias] = useState([]);
	const [listaTipoVeiculos, setListaTipoVeiculos] = useState([]);
	const [idAtual, setIdAtual] = useState();
	const [disable, setDisable] = useState(false);

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);
	const { setFiltrosRedux } = useContext(FiltrosRedux);

	const limpar = () => {
		setLoading(true);
		setValuesPesquisa([]);
		setDadosTabela(dadosTabelaCopia);
		setTimeout(() => {
			setLoading(false);
		}, 100);
	};

	const buscarSearch = async () => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${
			valuesPesquisa.pesquisa ?? ""
		}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getVeiculoSearch(profile?.token, pesquisaFormatada)
			.then((result) => {
				setDadosTabela(result.data);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const verificadorExistenciaVeiculo = async (placaCavalo) => {
		if (placaCavalo !== null && placaCavalo !== "") {
			await VerificaExistenciaVeiculo(profile?.token, placaCavalo)
				.then((result) => {
					if (result.data === true) {
						setTextoSucesso("Placa do caminhão não possui nenhum vínculo.");
						setOpenToastSucesso(true);
						setPlacaValida(true);
					} else {
						setTextoErro(
							"Placa do caminhão já possui um vínculo ativo, não será possível cadastrar novamente com ela."
						);
						setOpenToastErro(true);
						setPlacaValida(false);
					}
				})
				.catch(() => {
					setTextoErro(
						"Placa do caminhão já possui um vínculo ativo, não será possível cadastrar novamente com ela."
					);
					setOpenToastErro(true);
					setPlacaValida(false);
				});
		}
	};

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [openCadastro, setOpenCadastro] = useState(false);

	const handleCloseCadastro = (value) => {
		if (idAtual) {
			setOpenCadastro(false);
		} else {
			setLoadingSelectMotorista(true);
			buscarDependenciasSemLoading();
			setOpenCadastro(false);
		}
	};

	const [openCadastroProprietario, setOpenCadastroProprietario] =
		useState(false);

	const handleCloseCadastroProprietario = (value) => {
		if (idAtual) {
			setOpenCadastroProprietario(false);
		} else {
			setLoadingSelectProprietario(true);
			buscarDependenciasSemLoading();
			setOpenCadastroProprietario(false);
		}
	};

	const [openCadastroCaminhao, setOpenCadastroCaminhao] = useState(false);

	const handleCloseCadastroCaminhao = (value) => {
		if (idAtual) {
			setOpenCadastroCaminhao(false);
		} else {
			setLoadingSelectCaminhao(true);
			buscarDependenciasSemLoading();
			setOpenCadastroCaminhao(false);
		}
	};

	const [openCadastroCarreta, setOpenCadastroCarreta] = useState(false);

	const handleCloseCadastroCarreta = (value) => {
		if (idAtual) {
			setOpenCadastroCarreta(false);
		} else {
			setLoadingSelectCarreta(true);
			buscarDependenciasSemLoading();
			setOpenCadastroCarreta(false);
		}
	};

	const [openCadastroCarroceria, setOpenCadastroCarroceria] = useState(false);

	const handleCloseCadastroCarroceria = (value) => {
		if (idAtual) {
			setOpenCadastroCarroceria(false);
		} else {
			setLoadingSelectCarroceria(true);
			buscarDependenciasSemLoading();
			setOpenCadastroCarroceria(false);
		}
	};

	const [openCadastroTipoVeiculo, setOpenCadastroTipoVeiculo] = useState(false);

	const handleCloseCadastroTipoVeiculo = (value) => {
		if (idAtual) {
			setOpenCadastroTipoVeiculo(false);
		} else {
			setLoadingSelectTipoVeiculo(true);
			buscarDependenciasSemLoading();
			setOpenCadastroTipoVeiculo(false);
		}
	};

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const buscarDependencias = async () => {
		setLoading(true);
		await getVeiculoDependencias(profile?.token)
			.then((result) => {
				setListaProprietarios(result.data.proprietarios);
				setListaMotoristas(result.data.motoristas);
				setListaCaminhoes(result.data.caminhaos);
				setListaCarretas(result.data.carretas);
				setListaCarrocerias(result.data.tipoCarrocerias);
				setListaTipoVeiculos(result.data.tipoVeiculos);
				setListaCidade(result.data.cidadeEstados);
				setDadosTabela(result.data.veiculos);
				setDadosTabelaCopia(result.data.veiculos);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarDependenciasSemLoading = async () => {
		if (!profile) return;
		await getVeiculoDependencias(profile?.token)
			.then((result) => {
				setListaProprietarios(result.data.proprietarios);
				setListaMotoristas(result.data.motoristas);
				setListaCaminhoes(result.data.caminhaos);
				setListaCarretas(result.data.carretas);
				setListaCarrocerias(result.data.tipoCarrocerias);
				setListaTipoVeiculos(result.data.tipoVeiculos);
				setDadosTabela(result.data.veiculos);
				setTabelaRedux({});
				setLoadingSelectProprietario(false);
				setLoadingSelectMotorista(false);
				setLoadingSelectCaminhao(false);
				setLoadingSelectCarreta(false);
				setLoadingSelectCarroceria(false);
				setLoadingSelectTipoVeiculo(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoadingSelectProprietario(false);
				setLoadingSelectMotorista(false);
				setLoadingSelectCaminhao(false);
				setLoadingSelectCarreta(false);
				setLoadingSelectTipoVeiculo(false);
				setLoadingSelectCarroceria(false);
			});
	};

	const title = useMemo(() => {
		if (editando) return "Detalhes de Conjunto";
		if (telaCadastro) return "Cadastro de Conjunto";
		return "Conjuntos";
	}, [editando, telaCadastro]);

	const [listaCidade, setListaCidade] = useState([]);

	const validarCamposVazios = () => {
		if (validator.placaCavalo === "false") {
			setErroPlacaCavalo(true);
		}
		if (validator.proprietario === "false") {
			setErroProprietario(true);
		}
		if (validator.motorista === "false") {
			setErroMotorista(true);
		}
		if (validator.tipoCarroceria === "false") {
			setErroTipoCarroceria(true);
		}
		if (validator.tipoVeiculoConjuntos === "false") {
			setErroTipoVeiculo(true);
		}
		if (validator.elegivelBrf === "false") {
			setErroElegivelBrf(true);
		}
		if (validator.tipoVeiculo === "false") {
			setErroTipoVeiculoApiSul(true);
		}
	};

	const removerErrosVazios = () => {
		setErroPlacaCavalo(false);
		setErroProprietario(false);
		setErroMotorista(false);
		setErroTipoCarroceria(false);
		setErroTipoVeiculo(false);
		setErroElegivelBrf(false);
		setErroTipoVeiculoApiSul(false);
	};

	const cadastrar = useCallback(async () => {
		if (
			camposObrigatorios.every(
				(field) => values[field] && validator[field] === "true"
			)
		) {
			await cadastraVeiculo(values, profile?.token)
				.then((result) => {
					setLoading(true);
					if (result.status === 200) {
						setTelaCadastro(false);
						setValues({});
						setValuesSelect({});
						if (valuesPesquisa.pesquisa) {
							buscarDependencias();
						} else {
							buscarSearch();
						}
						shouldSearchDependencies();
						setDadosRequestControllerRedux("Fechar Modal Veiculo");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
					}
				})
				.catch((error) => {
					if (typeof error.response?.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	}, [
		values,
		profile?.token,
		valuesPesquisa.pesquisa,
		camposObrigatorios,
		validator,
		buscarDependencias,
		setDadosRequestControllerRedux,
		setTabelaRedux,
		shouldSearchDependencies,
	]);

	const editar = useCallback(async () => {
		if (camposObrigatorios.every((field) => values[field])) {
			setLoading(true);
			await editaVeiculoPorId(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						if (valuesPesquisa.pesquisa === undefined) {
							buscarDependencias();
						} else {
							buscarSearch();
						}
						setTabelaRedux({});
						setTextoSucesso("Editado Com Sucesso");
						setOpenToastSucesso(true);
						setTelaCadastro(false);
						setEditando(false);
						setValues({});
						setValuesSelect({});
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
						setOpenToastErro(true);
						setLoading(false);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
						setOpenToastErro(true);
						setLoading(false);
					}
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			validarCamposVazios();
			setOpenToastErro(true);
		}
	}, [
		values,
		profile?.token,
		valuesPesquisa.pesquisa,
		camposObrigatorios,
		validator,
		buscarDependencias,
		setTabelaRedux,
		buscarSearch,
		validarCamposVazios,
	]);

	const [elegivelValido, setElegivelValido] = useState(false);

	const preencherDadosEditando = async (result) => {
		let elegivelBrf;
		if (result.data.elegibilidadeBrf.length > 0) {
			if (
				result.data.elegibilidadeBrf[0].tipoElegibilidadeBrf ===
				ElegibilidadeBrf.BRF_A
			) {
				elegivelBrf = "BRF A";
			} else if (
				result.data.elegibilidadeBrf[0].tipoElegibilidadeBrf ===
				ElegibilidadeBrf.BRF_B
			) {
				elegivelBrf = "BRF B";
			} else if (
				result.data.elegibilidadeBrf[0].tipoElegibilidadeBrf ===
				ElegibilidadeBrf.BRF_C
			) {
				elegivelBrf = "BRF C";
			} else if (
				result.data.elegibilidadeBrf[0].tipoElegibilidadeBrf ===
				ElegibilidadeBrf.BRF_Spot
			) {
				elegivelBrf = "BRF Spot";
			} else if (
				result.data.elegibilidadeBrf[0].tipoElegibilidadeBrf ===
				ElegibilidadeBrf.BRF_OTM
			) {
				elegivelBrf = "BRF OTM";
			} else if (
				result.data.elegibilidadeBrf[0].tipoElegibilidadeBrf ===
				ElegibilidadeBrf.BRF_INELEGIVEL
			) {
				elegivelBrf = "BRF Inelegível";
			}
		}

		const elegivelBrfSelecionado = opcoesSelect.find(
			(option) => option.label === elegivelBrf
		);
		if (elegivelBrfSelecionado) {
			setValues((current) => ({
				...current,
				elegivelBrf: elegivelBrfSelecionado.valor,
			}));
			setValuesSelect((current) => ({
				...current,
				elegivelBrf: elegivelBrfSelecionado,
			}));
			setValidator((current) => ({
				...current,
				elegivelBrf: "true",
			}));
		}

		const tipoVeiculoSelecionado = opcoes.find(
			(opcao) => opcao.valor === result.data.tipoVeiculo
		);
		if (tipoVeiculoSelecionado) {
			setValuesSelect((current) => ({
				...current,
				tipoVeiculo: tipoVeiculoSelecionado,
			}));
			setValues((current) => ({
				...current,
				tipoVeiculo: tipoVeiculoSelecionado.valor,
			}));
			setValidator((current) => ({
				...current,
				tipoVeiculo: "true",
			}));
		}
		const placaCavaloSelecionado = listaCaminhoes.find(
			(option) => option.placa === result.data.caminhao.placa
		);
		if (placaCavaloSelecionado) {
			setValuesSelect((current) => ({
				...current,
				placaCavalo: {
					value: placaCavaloSelecionado.placa,
					label: placaCavaloSelecionado.placa,
					id: placaCavaloSelecionado.idCaminhao,
				},
			}));
			setValues((current) => ({
				...current,
				CaminhaoId: placaCavaloSelecionado.idCaminhao,
				placaCavalo: placaCavaloSelecionado.placa,
			}));
		} else {
			setValuesSelect((current) => ({
				...current,
				placaCavalo: {
					value: result.data.caminhao.placa,
					label: result.data.caminhao.placa,
					id: null,
				},
			}));
			setValues((current) => ({
				...current,
				CaminhaoId: null,
				placaCavalo: result.data.caminhao.placa,
			}));
		}
		const placaCarretaSelecionado = listaCarretas.find(
			(option) => option.placa === result.data.carreta?.placa
		);
		if (placaCarretaSelecionado) {
			setValuesSelect((current) => ({
				...current,
				placaCarreta: {
					value: placaCarretaSelecionado.placa,
					label: placaCarretaSelecionado.placa,
					id: placaCarretaSelecionado.idCarreta,
				},
			}));
			setValues((current) => ({
				...current,
				placaCarretaId: placaCarretaSelecionado.idCarreta,
			}));
		} else {
			setValuesSelect((current) => ({
				...current,
				placaCarreta: {
					value: result.data.carreta?.placa,
					label: result.data.carreta?.placa,
					id: null,
				},
			}));
		}
		const placaCarreta2Selecionado = listaCarretas.find(
			(option) => option.placa === result.data.carreta2?.placa
		);
		if (placaCarreta2Selecionado) {
			setValuesSelect((current) => ({
				...current,
				placaCarreta2: {
					value: placaCarreta2Selecionado.placa,
					label: placaCarreta2Selecionado.placa,
					id: placaCarreta2Selecionado.idCarreta,
				},
			}));
			setValues((current) => ({
				...current,
				carreta2Id: placaCarreta2Selecionado.idCarreta,
			}));
		} else {
			setValuesSelect((current) => ({
				...current,
				placaCarreta2: {
					value: result.data.carreta2?.placa,
					label: result.data.carreta2?.placa,
					id: null,
				},
			}));
		}
		const proprietarioSelecionado = listaProprietario.find(
			(option) => option.nome === result.data.proprietarioVeiculo?.nome
		);
		if (proprietarioSelecionado) {
			setValuesSelect((current) => ({
				...current,
				proprietario: {
					value: proprietarioSelecionado.nome,
					label: proprietarioSelecionado.nome,
					id: proprietarioSelecionado.idProprietario,
				},
			}));
			setValues((current) => ({
				...current,
				proprietarioId: proprietarioSelecionado.idProprietario,
				proprietario: proprietarioSelecionado.nome,
			}));
			setValidator((current) => ({
				...current,
				proprietario: "true",
			}));
		}
		const tipoCarroceriaSelecionado = listaCarrocerias.find(
			(option) => option.nome === result.data.tipoCarroceria?.nome
		);
		if (tipoCarroceriaSelecionado) {
			setValuesSelect((current) => ({
				...current,
				tipoCarroceria: {
					value: tipoCarroceriaSelecionado.nome,
					label: tipoCarroceriaSelecionado.nome,
					id: tipoCarroceriaSelecionado.id,
				},
			}));
			setValues((current) => ({
				...current,
				tipoCarroceriaId: tipoCarroceriaSelecionado.id,
			}));
			setValidator((current) => ({
				...current,
				tipoCarroceria: "true",
			}));
		}
		const tipoVeiculoConjuntosSelecionado = listaTipoVeiculos.find(
			(option) => option.nome === result.data.tipoVeiculoConjuntos?.nome
		);
		if (tipoVeiculoConjuntosSelecionado) {
			setValuesSelect((current) => ({
				...current,
				tipoVeiculoConjuntos: {
					value: tipoVeiculoConjuntosSelecionado.nome,
					label: tipoVeiculoConjuntosSelecionado.nome,
					id: tipoVeiculoConjuntosSelecionado.id,
				},
			}));
			setValues((current) => ({
				...current,
				tipoVeiculoId: tipoVeiculoConjuntosSelecionado.id,
			}));
			setValidator((current) => ({
				...current,
				tipoVeiculoConjuntos: "true",
			}));
		}
		const tipoVeiculoApiSulSelecionado = opcoesVeiculo.find(
			(option) => option.id === result.data.tipoVeiculo
		);

		if (tipoVeiculoApiSulSelecionado) {
			setValuesSelect((current) => ({
				...current,
				tipoVeiculo: {
					value: tipoVeiculoApiSulSelecionado.valor,
					label: tipoVeiculoApiSulSelecionado.label,
					id: tipoVeiculoApiSulSelecionado.value,
				},
			}));
			setValues((current) => ({
				...current,
				tipoVeiculo: tipoVeiculoApiSulSelecionado.id,
			}));
			setValidator((current) => ({
				...current,
				tipoVeiculo: "true",
			}));
		}

		const motoristaSelecionado = listaMotoristas.find(
			(option) => option.idMotorista === result.data?.motoristaId
		);
		if (motoristaSelecionado) {
			setValuesSelect((current) => ({
				...current,
				motorista: {
					value: motoristaSelecionado.nome,
					label: motoristaSelecionado.nome,
					id: motoristaSelecionado.idMotorista,
				},
			}));
			setValues((current) => ({
				...current,
				motoristaId: motoristaSelecionado.idMotorista,
				motorista: motoristaSelecionado.nome,
			}));
			setValidator((current) => ({
				...current,
				motorista: "true",
			}));
		}
		const motorista2Selecionado = listaMotoristas.find(
			(option) => option.idMotorista === result.data?.motorista2Id
		);
		if (motorista2Selecionado) {
			setValuesSelect((current) => ({
				...current,
				motorista2: {
					value: motorista2Selecionado.nome,
					label: motorista2Selecionado.nome,
					id: motorista2Selecionado.idMotorista,
				},
			}));
			setValues((current) => ({
				...current,
				motorista2Id: motorista2Selecionado.idMotorista,
			}));
		}
		const cidadeSelecionado = listaCidade.find(
			(option) => option.idCidadeEstado === result.data.cidadeEstadoId
		);
		if (cidadeSelecionado) {
			setValuesSelect((current) => ({
				...current,
				cidadeEstadoId: cidadeSelecionado,
			}));
		}

		const dataAtualizacaoLocalizacao = new Date(
			result.data.dataAtualizacaoLocalizacao
		);
		const isDateValid = dataAtualizacaoLocalizacao >= new Date("2000-01-01");

		setValues((current) => ({
			...current,
			agregado: result.data?.agregado ? true : false,
			telemetria: result.data?.telemetria ? true : false,
			dataAtualizacaoLocalizacao: isDateValid
				? dataAtualizacaoLocalizacao.toISOString().split("T")[0]
				: undefined,
		}));
	};

	const buscarVeiculoPorId = useCallback(async () => {
		setLoading(true);
		await getVeiculoPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					if (editando) {
						setValues(result.data);
						await preencherDadosEditando(result);
						campos2.forEach((campo, index) => {
							if (result.data[campo]) {
								setValidator((current) => ({
									...current,
									[campos[index]]: "true",
								}));
							}
						});
					}
				}
			})
			.catch((error) => {
				hasBuscadoVeiculoPorId.current = false;
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
				}
			});
		setLoading(false);
	}, [
		tabelaRedux.colunaSelecionada,
		preencherDadosEditando,
		profile?.token,
		editando,
	]);

	const buscarVeiculoPorIdModal = async (id) => {
		setLoading(true);
		await getVeiculoPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					await preencherDadosEditando(result);
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const deletarVeiculoPorId = async () => {
		setLoading(true);
		await deleteVeiculoPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarDependencias();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		setValues((current) => ({
			...current,
			usuario: profile?.usuario.usuario,
			...valoresIniciais,
		}));
		setValidator((current) => ({ ...current, ...validadoresIniciais }));
	}, [loading, profile?.usuario.usuario]);

	useEffect(() => {
		if (editando && profile?.token && !hasBuscadoVeiculoPorId.current) {
			buscarVeiculoPorId();
			hasBuscadoVeiculoPorId.current = true;
		}
	}, [editando, profile?.token, buscarVeiculoPorId]);

	useEffect(() => {
		if (telaCadastro) {
			setValues({
				agregado: false,
				placaCavalo: "",
				placaCarreta: "",
				placaCarreta2: "",
				proprietario: "",
				motorista: "",
				motorista2: "",
				tipoCarroceria: "",
				tipoVeiculo: "",
				tipoVeiculoConjuntos: "",
				ativoDiaria: "",
				elegivelBrf: "",
			});
		}
	}, [telaCadastro]);

	useEffect(() => {
		if (dadosRequestControllerRedux === "Fechar Modal Proprietario") {
			handleCloseCadastroProprietario();
			setDadosRequestControllerRedux("");
			setTextoSucesso("Cadastrado Com Sucesso");
			setOpenToastSucesso(true);
		}
		if (dadosRequestControllerRedux === "Fechar Modal Motorista") {
			handleCloseCadastro();
			setDadosRequestControllerRedux("");
			setTextoSucesso("Cadastrado Com Sucesso");
			setOpenToastSucesso(true);
		}
		if (dadosRequestControllerRedux === "Fechar Modal Caminhao") {
			handleCloseCadastroCaminhao();
			setDadosRequestControllerRedux("");
			setTextoSucesso("Cadastrado Com Sucesso");
			setOpenToastSucesso(true);
		}
		if (dadosRequestControllerRedux === "Fechar Modal Carreta") {
			handleCloseCadastroCarreta();
			setDadosRequestControllerRedux("");
			setTextoSucesso("Cadastrado Com Sucesso");
			setOpenToastSucesso(true);
		}
	}, [dadosRequestControllerRedux]);

	useEffect(() => {
		if (profile?.token) {
			buscarDependencias();
		}
	}, [profile?.token]);

	useEffect(() => {
		if (props.idAtual && profile?.token) {
			buscarVeiculoPorIdModal(props.idAtual);
		}
	}, [props.idAtual, profile?.token, buscarVeiculoPorIdModal]);

	useEffect(() => {
		if (telaCadastro && !editando) {
			setValues((current) => ({ ...current, ativoDiaria: true }));
		}
	}, [telaCadastro, editando]);

	useEffect(() => {
		if(!editando && !telaCadastro){
			hasBuscadoVeiculoPorId.current = false;
		}
	}, [editando, telaCadastro]);

	const labelCidadeEstado = (data) => (
		<div style={{ display: "flex", alignItems: "center" }}>
			{data.abreviacao ? data.abreviacao : data.cidade} - {data.estado}
			{valuesSelect.cidadeEstadoId === data && (
				<ClearIcon
					className="info-icon"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						clearCidade();
					}}
				/>
			)}
		</div>
	);

	const clearCidade = () => {
		setValues((current) => ({
			...current,
			cidadeEstadoId: null,
		}));
		setValuesSelect((current) => ({ ...current, cidadeEstadoId: "" }));
		setValidator((current) => ({
			...current,
			cidadeEstadoId: "false",
		}));
	};

	const opcoesCidadeEstado = useMemo(() => {
		return listaCidade.map((data) => ({
			value: data.idCidadeEstado,
			label: `${data.abreviacao ? data.abreviacao : data.cidade} - ${
				data.estado
			}`,
			...data,
		}));
	}, [listaCidade]);

	const getRowClassName = useCallback(
		(row) => {
			if (!tabelaRedux?.colunaSelecionada) return "";
			return row.idVeiculo === tabelaRedux.colunaSelecionada
				? "selecionado"
				: "";
		},
		[tabelaRedux?.colunaSelecionada]
	);

	const handleSingleClick = useCallback(
		(row) => {
			if (!row) return;
			setTabelaRedux({
				colunaSelecionada: row["idVeiculo"] ?? row.idVeiculo,
				usuarioAlteracao: row.usuario || row.usuarioAlteracao || null,
				dataAlteracao: row.data || row.dataAlteracao || null,
				row,
			});
		},
		[setTabelaRedux]
	);

	const handleDoubleClick = useCallback(() => {
		setTelaCadastro(true);
		setEditando(true);
	}, []);

	const handleRowClick = useRowClick({
		idKey: "idVeiculo",
		onSelect: handleSingleClick,
		onDouble: handleDoubleClick,
	});

	const renderCell = useCallback((coluna, row) => {
		if (coluna.objetoEndereco === "true") {
			const endereco = row.endereco;
			if (!endereco) return "";

			return `${endereco.rua ?? ""}, ${endereco.numero ?? ""}, ${
				endereco.bairro ?? ""
			} - ${endereco.cidade ?? ""}`;
		}
		if (coluna.field === "elegivelBrf") {
			const label =
				opcoesBrfMapper.find((opcao) => opcao.value === Number(row.elegivelBrf))
					?.label ?? "";
			return label;
		}
		if (coluna.field === "cidadeEstado") {
			return `${row.cidadeEstado?.cidade ?? ""} - ${
				row.cidadeEstado?.estado ?? ""
			}`;
		}

		return undefined;
	}, []);

	useEffect(() => {
		if (props.telaCadastro) {
			setTelaCadastro(true);
			hasBuscadoVeiculoPorId.current = false;
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Veiculo"));
		}
	}, [profile, hasRegra]);

	const clearPlacaCavalo = () => {
		setValuesSelect((current) => ({ ...current, placaCavalo: "" }));
		setValues((current) => ({ ...current, CaminhaoId: "" }));
		setValues((current) => ({ ...current, placaCavalo: "" }));
		setValidator((current) => ({ ...current, placaCavalo: "false" }));
		setPlacaValida(true);
	};

	const clearPlacaCarreta = () => {
		setValuesSelect((current) => ({ ...current, placaCarreta: "" }));
		setValues((current) => ({ ...current, placaCarreta: "" }));
		setValues((current) => ({ ...current, carretaId: null }));
		setValidator((current) => ({ ...current, placaCarreta: "false" }));
	};

	const clearPlacaCarreta2 = () => {
		setValuesSelect((current) => ({ ...current, placaCarreta2: "" }));
		setValues((current) => ({ ...current, placaCarreta2: "" }));
		setValues((current) => ({ ...current, carreta2Id: null }));
		setValidator((current) => ({ ...current, placaCarreta2: "false" }));
	};

	const clearTipoCarroceria = () => {
		setValuesSelect((current) => ({ ...current, tipoCarroceria: "" }));
		setValues((current) => ({ ...current, tipoCarroceria: "" }));
		setValues((current) => ({ ...current, tipoCarroceriaId: null }));
		setValidator((current) => ({ ...current, tipoCarroceria: "false" }));
	};

	const clearTipoVeiculo = () => {
		setValuesSelect((current) => ({ ...current, tipoVeiculoConjuntos: "" }));
		setValues((current) => ({ ...current, tipoVeiculoConjuntos: "" }));
		setValues((current) => ({ ...current, tipoVeiculoId: null }));
		setValidator((current) => ({ ...current, tipoVeiculoConjuntos: "false" }));
	};

	const clearProprietario = () => {
		setValuesSelect((current) => ({ ...current, proprietario: "" }));
		setValues((current) => ({ ...current, proprietario: "" }));
		setValues((current) => ({ ...current, proprietarioId: null }));
		setValidator((current) => ({ ...current, proprietario: "false" }));
	};

	const clearMotorista = () => {
		setValuesSelect((current) => ({ ...current, motorista: "" }));
		setValues((current) => ({ ...current, motorista: "" }));
		setValues((current) => ({ ...current, motoristaId: null }));
		setValidator((current) => ({ ...current, motorista: "false" }));
	};

	const clearMotorista2 = () => {
		setValuesSelect((current) => ({ ...current, motorista2: "" }));
		setValues((current) => ({ ...current, motorista2Id: null }));
		setValues((current) => ({ ...current, motorista2: "" }));
		setValidator((current) => ({ ...current, motorista: "false" }));
	};

	const location = useLocation();

	useEffect(() => {
		setValuesPesquisa((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
		setFiltrosRedux((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
	}, [location.pathname, contextoEmbarque]);

	const biggerDevices = useMemo(() => {
		return window.innerWidth >= 1650;
	}, []);

	const isLoading = useMemo(() => {
		return (
			loading ||
			!profile?.token ||
			(!dadosTabela.length && hasBuscadoVeiculos.current)
		);
	}, [loading, profile?.token, dadosTabela.length]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer animationKey="VeiculoScreen">
						<div className="content-container">
							<div>
								<Separator size="md" />
								<FiltroV2
									classe="div-filtrar-embarque-v2"
									classOption="select-options-cliente"
									itensFiltro={itensFiltro}
									valuesPesquisa={valuesPesquisa}
									setValuesPesquisa={setValuesPesquisa}
									buscarSearch={buscarSearch}
									limpar={limpar}
								/>
								<Separator size="md" />
							</div>
							<TabelaVirtualizadaGenerica
								dados={dadosTabela}
								colunas={colunasEmpresaInicial.Veiculo}
								rowHeight={20}
								isLoading={isLoading}
								getRowClassName={getRowClassName}
								renderCell={renderCell}
								onRowClick={handleRowClick}
								centralized={biggerDevices}
							/>
						</div>
						<div className="footer-space-between">
							<div>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setTelaCadastro(true);
										setEditando(false);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
							<div>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
						</div>
					</MotionContainer>
				) : (
					<VeiculoCadastro
						desabilitar={props.desabilitar}
						botaoFechar={props.botaoFechar}
						botaoCadastrar={props.botaoCadastrar}
						botaoVoltar={props.botaoVoltar}
						editando={editando}
						setValues={setValues}
						removerErrosVazios={removerErrosVazios}
						setValuesSelect={setValuesSelect}
						setTelaCadastro={setTelaCadastro}
						setEditando={setEditando}
						validator={validator}
						setValidator={setValidator}
						loadingSelectCaminhao={loadingSelectCaminhao}
						verificadorExistenciaVeiculo={verificadorExistenciaVeiculo}
						setErroPlacaCavalo={setErroPlacaCavalo}
						setDisable={setDisable}
						setOpenCadastroCaminhao={setOpenCadastroCaminhao}
						clearPlacaCavalo={clearPlacaCavalo}
						setIdAtual={setIdAtual}
						valuesSelect={valuesSelect}
						placaValida={placaValida}
						erroPlacaCavalo={erroPlacaCavalo}
						listaCaminhoes={listaCaminhoes}
						loadingSelectCarreta={loadingSelectCarreta}
						setOpenCadastroCarreta={setOpenCadastroCarreta}
						clearPlacaCarreta={clearPlacaCarreta}
						listaCarretas={listaCarretas}
						clearPlacaCarreta2={clearPlacaCarreta2}
						loadingSelectProprietario={loadingSelectProprietario}
						setErroProprietario={setErroProprietario}
						setOpenCadastroProprietario={setOpenCadastroProprietario}
						clearProprietario={clearProprietario}
						listaProprietario={listaProprietario}
						erroProprietario={erroProprietario}
						setErroMotorista={setErroMotorista}
						setOpenCadastro={setOpenCadastro}
						clearMotorista={clearMotorista}
						listaMotoristas={listaMotoristas}
						erroMotorista={erroMotorista}
						loadingSelectMotorista={loadingSelectMotorista}
						clearMotorista2={clearMotorista2}
						erroTipoVeiculoApiSul={erroTipoVeiculoApiSul}
						setErroTipoVeiculoApiSul={setErroTipoVeiculoApiSul}
						loadingSelectCarroceria={loadingSelectCarroceria}
						setErroTipoCarroceria={setErroTipoCarroceria}
						setOpenCadastroCarroceria={setOpenCadastroCarroceria}
						clearTipoCarroceria={clearTipoCarroceria}
						listaCarrocerias={listaCarrocerias}
						erroTipoCarroceria={erroTipoCarroceria}
						loadingSelectTipoVeiculo={loadingSelectTipoVeiculo}
						setErroTipoVeiculo={setErroTipoVeiculo}
						setOpenCadastroTipoVeiculo={setOpenCadastroTipoVeiculo}
						clearTipoVeiculo={clearTipoVeiculo}
						listaTipoVeiculos={listaTipoVeiculos}
						erroTipoVeiculo={erroTipoVeiculo}
						elegivelValido={elegivelValido}
						erroElegivelBrf={erroElegivelBrf}
						setElegivelValido={setElegivelValido}
						setErroElegivelBrf={setErroElegivelBrf}
						opcoesCidadeEstado={opcoesCidadeEstado}
						labelCidadeEstado={labelCidadeEstado}
						cadastrar={cadastrar}
						validarCamposVazios={validarCamposVazios}
						classeCss={props.classeCss}
						values={values}
						editar={editar}
					/>
				)}
			</AnimatePresence>
			<ModaisVeiculos
				open={open}
				handleClose={handleClose}
				deletarVeiculoPorId={deletarVeiculoPorId}
				openCadastro={openCadastro}
				handleCloseCadastro={handleCloseCadastro}
				openCadastroProprietario={openCadastroProprietario}
				handleCloseCadastroProprietario={handleCloseCadastroProprietario}
				openCadastroCaminhao={openCadastroCaminhao}
				handleCloseCadastroCaminhao={handleCloseCadastroCaminhao}
				openCadastroCarreta={openCadastroCarreta}
				handleCloseCadastroCarreta={handleCloseCadastroCarreta}
				openCadastroCarroceria={openCadastroCarroceria}
				handleCloseCadastroCarroceria={handleCloseCadastroCarroceria}
				openCadastroTipoVeiculo={openCadastroTipoVeiculo}
				handleCloseCadastroTipoVeiculo={handleCloseCadastroTipoVeiculo}
				openUsuario={openUsuario}
				handleCloseUsuario={handleCloseUsuario}
				disable={disable}
			/>
			<ToastSucesso
				texto={textoSucesso}
				open={openToastSucesso}
				onClose={handleCloseToastSucesso}
			/>
			<ToastErro
				texto={textoErro}
				open={openToastErro}
				onClose={handleCloseToastErro}
			/>
		</Layout>
	);
}

export default Veiculo;
